import React, { useState } from 'react';
import { BASE_URL } from '../config/api'; // Ensure your BASE_URL is correct
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

const OutStock = () => {
    const [amount, setAmount] = useState('');
    const [description, setDescription] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        const data = {
            staff_id: 1,
            amount: parseFloat(amount),
            transaction_type: 'OUTGOING', // For outgoing stock
            description: description,
        };

        try {
            const response = await fetch(`${BASE_URL}officestocks/transaction`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(data),
            });

            const result = await response.json();

            if (result.status === 1) {
Swal.fire({
  icon: "success",
  title: "OUTGOING transaction successful",
});                navigate('/OfficeStocksList'); // Redirect after successful transaction
            } else {
                alert('Failed to remove stock');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('There was an error while removing the stock.');
        }
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Out Stock</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="form-group mb-3">
                                        <label htmlFor="amount" className="form-label">Amount</label>
                                        <input
                                            type="number"
                                            className="form-control"
                                            id="amount"
                                            placeholder="Enter the amount"
                                            value={amount}
                                            onChange={(e) => setAmount(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="form-group mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="description"
                                            placeholder="Enter description"
                                            value={description}
                                            onChange={(e) => setDescription(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <button type="submit" className="btn btn-danger">Out Stock</button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default OutStock;
